import RegEx from './FormUtils/RegEx';

export const removeSlash = (string: string): string => {
  return string.replace(RegEx.removeSlash, '');
};
